/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { Sparkles, useGLTF } from "@react-three/drei";
import { Color } from "three";
import { GLTFResult } from "./types";

export function Bicycle(props: JSX.IntrinsicElements["group"]) {
  const { nodes, materials } = useGLTF("/bicycle.glb") as GLTFResult;

  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object_3.geometry}
        material={materials.initialShadingGroup}
        material-envMapIntensity={2}
        material-roughness={0.2}
      />
      <mesh geometry={nodes.Object_3001.geometry}>
        <meshBasicMaterial
          toneMapped={false}
          color={new Color("#ffd242").multiplyScalar(10)}
        />

        <Sparkles
          position={[-0.362144, 1.6, -0.844872]}
          color={new Color("#ffedb1").multiplyScalar(5)}
          noise={100}
          size={0.5}
          count={5}
          scale={0.5}
          speed={2.5}
          rotation-y={Math.PI / 4}
        />
      </mesh>
    </group>
  );
}
